import { render, staticRenderFns } from "./PasswordForgottenForm.vue?vue&type=template&id=4d256fc1"
import script from "./PasswordForgottenForm.vue?vue&type=script&lang=js"
export * from "./PasswordForgottenForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports